module.exports = __webpack_public_path__ + "c110ed6ef7706f23b60fdff7dd2e75a2.pdf";